<template>
  <div class="item-card">
    <div class="item-card-titulo">{{ title }}</div>
    <div class="item-card-valor">{{ value }}</div>
    <div v-if="subtitle">
      <hr />
      <div class="item-card-titulo">{{ subtitle }}</div>
      <div class="item-card-valor">{{ subvalue }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ItemCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    subvalue: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.item-card {
  text-align: center;
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 25px 10px;
  justify-content: space-between;
  align-items: center;
  color: #6c757d;
  margin-right: 5px;
  .item-card-valor {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    color: #000;
  }
  .item-card-titulo {
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
.relatorio-card-link {
  @include transition-all();
}
hr {
  color: #e9ecef !important;
  border-color: #e9ecef !important;
  border-width: 2px;
}
.pdf-content {
  .item-card {
    .item-card-valor {
      font-size: 14px !important;
    }
    .item-card-titulo {
      font-size: 12px !important;
      font-weight: 500;
    }
  }
}
</style>
